import { resolveTopAuthorId } from "../constants/TopAuthors";
import { ApiUtility } from "./ApiUtility";
import ArticlesService from "./Articles";
import AudiosService from "./Audios";
import BooksService from "./Books";

class AuthorsService {
  route = "/posts";
  authorRoute = "/api/authors/slug-";
  autroute = "/api/authors?lang=";
  authorsRoute = "/api/settings/filters?lang=";
  /** Sliders only need a page of items; full /api/authors/{id} catalogs are slow locally */
  sliderPageSize = 12;

  getFilters = (lang?: string, productFor?: string) => {
    return ApiUtility.get(
      this.authorsRoute + lang + "&productFor=" + productFor
    );
  };

  getAuthorData = (authorfor: any, limit: any) =>
    ApiUtility.get(this.autroute + localStorage.getItem("lan"), {
      authorfor,
      limit,
    });

  getAuthors = (id: string, lang: string) => {
    return ApiUtility.get(
      this.authorRoute +
        "5bbc60101fd2d735b0087d36?lang=" +
        lang
    );
  };

  /**
   * Light author profile (name, intro HTML). Uses /api/Books/Authors/{id|slug-…}.
   * Do not call /api/authors/{id} here — that endpoint embeds every related item and is slow.
   */
  GetAuthorDataById = async (idOrSlug: string, userId?: string) => {
    const logdetails: string[] = [];
    logdetails.push("action=GetAuthorDataById");
    logdetails.push(`idOrSlug=${idOrSlug || "none"}`);

    const lang = localStorage.getItem("lan") || "hindi";
    const resolvedId = resolveTopAuthorId(idOrSlug);
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(resolvedId || "");
    const identifier = isMongoId ? resolvedId : `slug-${idOrSlug}`;

    logdetails.push(`identifier=${identifier}`);
    logdetails.push("url=/api/Books/Authors/{id|slug}");
    if (userId) {
      logdetails.push(`userId=${userId}`);
    }
    console.log("AuthorsService ->", logdetails.join(" | "));
    return ApiUtility.get(`/api/Books/Authors/${identifier}?lang=${lang}`);
  };

  /** First page of books/audios/pravachans/articles plus totals for the author sliders */
  getAuthorSliderCollections = async (authorId: string) => {
    const logdetails: string[] = [];
    logdetails.push("action=getAuthorSliderCollections");
    logdetails.push(`authorId=${authorId || "none"}`);
    logdetails.push(`pageSize=${this.sliderPageSize}`);

    const empty = { items: [] as any[], total: 0 };
    const pickList = (res: any) => ({
      items: Array.isArray(res?.result?.items) ? res.result.items : [],
      total: Number(res?.result?.totalRecords) || 0,
    });

    try {
      const [booksRes, audiosRes, pravachansRes, articlesRes] = await Promise.all([
        BooksService.getBooks(0, this.sliderPageSize, false, "", authorId, "", "3", "", false),
        AudiosService.getAudios(0, this.sliderPageSize, false, "", authorId, "", "3", "", false, "audios", 0, "", ""),
        AudiosService.getAudios(0, this.sliderPageSize, false, "", authorId, "", "3", "", false, "pravachans", 0, "", ""),
        ArticlesService.getArticles(0, this.sliderPageSize, false, "", authorId, "", "3", "", false),
      ]);

      const books = pickList(booksRes);
      const audios = pickList(audiosRes);
      const pravachans = pickList(pravachansRes);
      const articles = pickList(articlesRes);

      logdetails.push(`books=${books.items.length}/${books.total}`);
      logdetails.push(`audios=${audios.items.length}/${audios.total}`);
      logdetails.push(`pravachans=${pravachans.items.length}/${pravachans.total}`);
      logdetails.push(`articles=${articles.items.length}/${articles.total}`);
      logdetails.push("status=success");
      console.log("AuthorsService ->", logdetails.join(" | "));

      return { books, audios, pravachans, articles };
    } catch (error: any) {
      logdetails.push(`status=error`);
      logdetails.push(`error=${error?.message || "unknown"}`);
      console.log("AuthorsService ->", logdetails.join(" | "));
      return { books: empty, audios: empty, pravachans: empty, articles: empty };
    }
  };
}
export default new AuthorsService();
